export default __webpack_public_path__ + "static/media/Slide2.63894a5f.png";